import {gql} from '@apollo/client';
import {AUDIO_TYPE, IMAGE_TYPE, VIDEO_TYPE} from './mediaType';
import {COURSE_TYPE} from './courses';
export const UNIT_TYPE = `
  id
  title
  description
  order
  participationType
  poster {
    ${IMAGE_TYPE}
  }
  cover {
    ${IMAGE_TYPE}
  }
  video {
    ${VIDEO_TYPE}
  }
  audio {
    ${AUDIO_TYPE}
  }
  unitType
`;

export const MUTATION_UNIT_BY_COURSE_MODULE = gql`
  mutation createOrUpdateUnitByCourseModule(
    $courseModuleId: ID!,
    $id: ID,
    $title: String!,
    $description: String!,
    $unitType: String!,
    $participationType: String!,
    $order: Int,
    $posterUrl: String,
    $coverUrl: String,
    $videoUrl: String,
    $audioUrl: String,
    $_destroy: Boolean,
  ){
    unitByCourseModule(input: {
      courseModuleId: $courseModuleId,
      id: $id,
      title: $title,
      description: $description,
      unitType: $unitType,
      participationType: $participationType,
      order: $order,
      posterUrl: $posterUrl,
      coverUrl: $coverUrl,
      videoUrl: $videoUrl,
      audioUrl: $audioUrl,
      _destroy: $_destroy,
    }){
      unit{
        ${UNIT_TYPE}
      }
    }
  }
`;
